module.exports = __webpack_public_path__ + "static/37-should-your-organization-offer-and-pay-for-retraining-opportunities-c2007a339d03781fbfed29f492ffba84.jpg";